import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "accounts-icon",
  role: "img",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M27,15c0-6.6-5.4-12-12-12S3,8.4,3,15s5.4,12,12,12v-6c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6H27z" }, null, -1),
    _createElementVNode("rect", {
      x: "21",
      y: "21",
      width: "6",
      height: "6"
    }, null, -1)
  ])))
}
export default { render: render }